<template>
    <v-card class="pa-1" color="" :height="height" :outlined="outlined" flat tile>  
        <v-layout  v-if="selected_items" fill-height column class=" receipt-border ">
            <v-simple-table class="b1 mx-1 mt-2" :height="vsh_payment_sam_table-10" fixed-header dense>
                <template v-slot:default>
                    <thead>
                        <tr class="font-weight-bold ">
                            <th class=" text-left "> 
                            </th>
                            <th class=" text-left ">
                                ITEM
                            </th>
                            <th class="text-center "> 
                                <span  > 
                                    PRICE
                                </span>
                            </th>
                            <th class="text-center ">
                                QTY
                            </th> 
                            <th class="text-center ">
                                TOTAL <span v-if="CalculatedVAT?CalculatedVAT.total_vat:false">(EX VAT)</span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(item,index) in selected_items"
                            :key="item.key" >
                            <td class="pl- text- with-divider-lr table-background1">{{ index+1 }}</td>
                            <td class="pl- text- with-divider">{{ item.name }}</td>
                            <td class=" text-right with-divider"> 
                                <span  > 
                                    {{ item.sold_price }}
                                </span>
                            </td> 
                            <td class=" text-center with-divider">{{ item.quantity }}</td> 
                            <td class=" text-right with-divider">{{MBS.actions.money(PriceExcludeVAT(CALCULATE_PRICE(item),item.tax_group_code))}} </td>
                            <td class=" text-right with-divider" style="width:40px;" >{{
                                item.tax_group_code?item.tax_group_code:"A"
                            }}</td>
                        </tr>
                        <!-- <v-divider class="mx-3"></v-divider> -->
                    </tbody>
                </template>
            </v-simple-table>
            <v-spacer></v-spacer>
            <!-- <v-divider class="mx-3"></v-divider> -->
            <v-list color="transparent" >
                <template>
                    <v-list-item   v-if="false" 
                        :key="index"  v-for="(item, index) in selected_items">
                        <template >  
                            <v-list-item-content>
                                <v-list-item-title>
                                        {{item.name}}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                        {{item.pricing_tier}}: {{item.quantity}} X {{item.sold_price}}
                                </v-list-item-subtitle> 
                            </v-list-item-content>
                            <v-list-item-action>
                                {{MBS.actions.money(CALCULATE_PRICE(item))}} 
                            </v-list-item-action>   
                        </template> 
                    </v-list-item>
                </template>

                <!-- //show discount -->
                <div v-if="TotalDiscount||(CompanySettings?CompanySettings.calculate_vat:false)">
                    <v-divider class="" />  
                    <v-list-item  dense   >
                        <v-list-item-content >
                            <div class="not-f2 font-weight-bold">SUB-TOTAL</div>
                            <div v-if="TotalDiscount" class="not-f2 font-weight-bold">DISCOUNT</div> 
                            
                        </v-list-item-content>
                        <v-list-item-action>
                            <div class="not-f2 font-weight-bold">
                                <span v-if="CalculatedVAT">
                                    <span v-if="CalculatedVAT.vat_exclusive">{{MBS.actions.money(toNumber(TotalPrice))}}</span>
                                    <span v-else>{{MBS.actions.money(toNumber(TotalPrice)-toNumber(CalculatedVAT.total_vat))}}</span> 
                                </span>
                                <span v-else>{{MBS.actions.money(TotalPrice)}}</span>
                            </div>
                            <div v-if="TotalDiscount" class="not-f2 font-weight-bold">{{MBS.actions.money(TotalDiscount)}}</div>  
                        </v-list-item-action>   
                    </v-list-item> 
                </div>
                
                <!-- //show VAT -->
                <div v-if="CompanySettings?CompanySettings.calculate_vat:false">
                    <v-divider class=" mb-2" />
                    <span class="grey--text text--darken-2 " v-if="CalculatedVAT" > 
                        <span v-if="CalculatedVAT.taxable_a" >
                            <v-layout class="mx-3 ">
                                <div class="not-f2 font-weight-bold">TAXABLE A-17.5%</div>
                                <v-spacer/>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_a)}}</div>
                            </v-layout> 
                            <v-layout class="mx-3">
                                <div class="not-f2 font-weight-bold">VAT A-17.5%</div>
                                <v-spacer/>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_a)}}</div>
                            </v-layout>   
                        </span>
                        
                        <span v-if="CalculatedVAT.taxable_b">
                            <v-layout class="mx-3">
                                <div class="not-f2 font-weight-bold">TAXABLE B-0%</div>
                                <v-spacer/>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_b)}}</div>
                            </v-layout> 
                            <v-layout class="mx-3">
                                <div class="not-f2 font-weight-bold">VAT B-0%</div>
                                <v-spacer/>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_b)}}</div>
                            </v-layout>   
                        </span>
                        
                        <span v-if="CalculatedVAT.taxable_c">
                            <v-layout class="mx-3">
                                <div class="not-f2 font-weight-bold">TAXABLE E-0%</div>
                                <v-spacer/>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_c)}}</div>
                            </v-layout> 
                            <v-layout class="mx-3">
                                <div class="not-f2 font-weight-bold">VAT E-0%</div>
                                <v-spacer/>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_c)}}</div>
                            </v-layout> 
                        </span>

                        <v-layout class="mx-3 mt-2 mb-2 grey--text text--darken-3">
                            <div class="not-f3 font-weight-bold">TOTAL VAT</div>
                            <v-spacer/>
                            <div class="not-f3 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.total_vat)}}</div>
                        </v-layout>   
                    </span>

                    <v-list-item  dense  class="grey--text text--darken-2" v-if="false" >
                        <v-list-item-content >
                            <span class='mb-2'>
                                <div class="not-f2 font-weight-bold">TAXABLE A-17.5%</div>
                                <div class="not-f2 font-weight-bold">VAT A-17.5%</div>  
                            </span>
                            <span class='mb-2'>
                                <div class="not-f2 font-weight-bold">TAXABLE B-0%</div> 
                                <div class="not-f2 font-weight-bold">VAT B-0%</div>  
                            </span>
                            <span>
                                <div class="not-f2 font-weight-bold">TAXABLE C-0%</div> 
                                <div class="not-f2 font-weight-bold">VAT C-0%</div>  
                            </span>
                            
                            <div class="not-f3 font-weight-bold grey--text text--darken-3">TOTAL VAT</div> 
                        </v-list-item-content>
                        <v-list-item-action>
                            <span class='mb-2'>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_a)}}</div>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_a)}}</div>  
                            </span>
                            <span class='mb-2'>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_b)}}</div> 
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_b)}}</div>  
                            </span>
                            <span>
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.taxable_c)}}</div> 
                                <div class="not-f2 font-weight-bold"> {{MBS.actions.money(CalculatedVAT.vat_c)}}</div>  
                            </span>
                            <div class="not-f3 font-weight-bold grey--text text--darken-3"> {{MBS.actions.money(CalculatedVAT.total_vat)}}</div> 
                        </v-list-item-action>   
                    </v-list-item> 
                </div>
                
                <v-divider /> 
                <v-list-item     class="grey--text text--darken-3 mx- px-2" >
                    <v-list-item-content>
                        <v-layout class="ma-0 " align-center>
                            <div class="font-weight-bold not-f6">TOTAL PRICE:</div>
                            <!-- <div class="pl-2 font-weight-bold not-f3">{{MBS.actions.SIZE(selected_items)}} items</div>  -->
                        </v-layout>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-layout class="ma-0" align-center>
                            <div class="font-weight-bold not-f3 pt-1 ">MWK </div>
                            <div class="font-weight-bold not-f6">{{MBS.actions.money(TotalDiscountedPrice)}}</div>
                        </v-layout> 
                    </v-list-item-action>   
                </v-list-item> 
            </v-list>  
        </v-layout> 
        <v-layout v-else-if="!selected_items" fill-height align-center justify-center >
            No Item
        </v-layout> 
    </v-card>
</template> 
<script> 

    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex"  
    const PAGE_NAME = "SALE-ACTIONS"

    export default {
        props:['height',"outlined","click_mode","selected_items","vsh_payment_sam_table","TotalPrice","TotalDiscount","TotalDiscountedPrice","CalculatedVAT","PriceExcludeVAT","CALCULATE_PRICE","PaymentMethodsData","DisabledOnAccountFields","item_order","DataSource"],
        data(){
            return{
                show:false,    
                DATA:DATA,   
                 
            }
        },
        created(){ 
            try { 
                 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted(){  
        },
        computed:{
            vs(){
                let vs = this.$vuetify.breakpoint  
                return vs
            }, 
            vs_width(){
                let vs = this.vs
                if(!vs){return null}
                return vs.width
            },
            vsh(){
                return this.vs.height
            }, 
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
                K_CONNECTOR: state=> state.items['K_CONNECTOR'],
            }),
            ...mapState({
                CompanySettings: state=> state.items[(DATA.ITEMS.COMPANY_SETTINGS.values).toUpperCase()], 
                CompanyQuickActions: state=> state.items[(DATA.ITEMS.COMPANY_QUICK_ACTIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                ItemDepartments: state=> state.items[(DATA.ITEMS.ITEM_DEPARTMENTS.values).toUpperCase()], 
            }),  
        },
        methods:{  
             

        },
        beforeDestroy(){
            try {    
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch:{  
             
        }  
    }
</script> 